<template>
    <div class="mainWrapper pb-0">
   <section class="blockElement space position-relative reatesPage">
      <div class="container">
         <div class="row">
            <div class="col-12">
               <div class="flex-between">
                  <h1 class="mb-2 f-30 bold">{{$t('privacy_policy.privacytitle')}}</h1>
               </div>
            </div>
            <div class="col-12">
               <div class="static">
                  <h5>{{$t('privacy_policy.privacycontent1')}}</h5>
                  <p>{{$t('privacy_policy.privacycontent2')}} </p>
                  <ul class="list-disc">
                     <li>{{$t('privacy_policy.privacycontent3')}}</li>
                     <li>{{$t('privacy_policy.privacycontent4')}}</li>
                     <li v-html="$t('privacy_policy.privacycontent5')"> </li>
                  </ul>
                    <p v-html="$t('privacy_policy.privacycontent6')"></p>
                    <h5>{{$t('privacy_policy.privacycontent7')}} </h5>
                    <p v-html="$t('privacy_policy.privacycontent8')"></p>
                    <h5>{{$t('privacy_policy.privacycontent9')}}</h5>
                    <p>{{$t('privacy_policy.privacycontent10')}} </p>
                    <h5>{{$t('privacy_policy.privacycontent11')}}</h5>
                    <p>{{$t('privacy_policy.privacycontent12')}} </p>
                    <h5>{{$t('privacy_policy.privacycontent13')}} </h5>
                    <p>{{$t('privacy_policy.privacycontent14')}} </p>
               </div>
            </div>
         </div>
      </div>
   </section>
</div>
</template>